export default __webpack_public_path__ + "static/media/logoForPrint.5d83d73d.png";